<template>
	<date-range-picker
		ref="picker"
		opens="right"
		:locale-data="localeDate"
		:showWeekNumbers="false"
		:showDropdowns="true"
		:autoApply="false"
		:ranges="ranges"
		@update="updateDateRange"
		v-model="dateRange"
	>
		<template v-if="dateRange.startDate && dateRange.endDate" v-slot:input="picker">
			{{ picker.startDate | date }} - {{ picker.endDate | date }}
		</template>
		<template v-else v-slot:input>
			{{ placeholder }}
		</template>
	</date-range-picker>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";

export default {
	components: { DateRangePicker },
	props: {
		value: {
			type: Object,
			required: true,
		},
		placeholder: {
			type: String,
			default: "Selecione um periodo",
		},
	},
	data() {
		return {
			dateRange: this.value,
			localeDate: {
				direction: "ltr",
				format: "dd/mm/yyyy",
				separator: " - ",
				applyLabel: "Aplicar",
				cancelLabel: "Cancelar",
				weekLabel: "W",
				customRangeLabel: "Custom Range",
				daysOfWeek: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
				monthNames: [
					"Jan",
					"Fev",
					"Mar",
					"Abr",
					"Mai",
					"Jun",
					"Jul",
					"Ago",
					"Set",
					"Out",
					"Nov",
					"Dez",
				],
				firstDay: 0,
			},
		};
	},
	computed: {
		ranges() {
			let today = new Date();
			today.setHours(0, 0, 0, 0);

			let yesterday = new Date();
			yesterday.setDate(today.getDate() - 1);
			yesterday.setHours(0, 0, 0, 0);

			let lastWeek = new Date();
			lastWeek.setDate(today.getDate() - 7);
			lastWeek.setHours(0, 0, 0, 0);

			return {
				Hoje: [today, today],
				Ontem: [yesterday, yesterday],
				"Última Semana": [lastWeek, today],
				"Mês Atual": [
					new Date(today.getFullYear(), today.getMonth(), 1),
					new Date(today.getFullYear(), today.getMonth(), 30),
				],
				"Ano Atual": [
					new Date(today.getFullYear(), 0, 1),
					new Date(today.getFullYear(), 11, 31),
				],
				"Mês Passado": [
					new Date(today.getFullYear(), today.getMonth() - 1, 1),
					new Date(today.getFullYear(), today.getMonth(), 0),
				],
				"Todo Período": [
					new Date(2020, 0, 1),
					new Date(today.getFullYear(), today.getMonth(), today.getDate()),
				],
			};
		},
	},
	watch: {
		value(newVal) {
			this.dateRange = newVal;
		},
	},
	methods: {
		updateDateRange(dateRange) {
			this.$emit("input", dateRange);
		},
	},
};
</script>

<style scoped>
::v-deep(.reportrange-text) {
    height: 40px !important;
    padding: 0px 12px !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center;
}
</style>
